export default "__VITE_ASSET__BlcahNaa__"